<template>
  <qx-card-form title="油/ETC标准比例设置">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="160px"
    />
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '油比例',
            value: 'oilScale',
            type: 'input',
          },
          {
            label: 'ETC比例',
            value: 'etcScale',
            type: 'input',
          },
        ],
        rules: {
          oilScale: [ // 油比例
            { required: true, message: '请输入油比例', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async sub () {
      const result = {};
      const formData = await this.$refs.baseForm.sub();
      Object.keys(formData).forEach((key) => {
        result[`creditRatingRules_0.${key}`] = formData[key];
      });
      return result;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      return res;
    },
    async init (data = {}) {
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
